import { Clock } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// The AI provider's OWN daily limit (Universal Key proxy), not our spend gate: what was refused, who waits, next probe.
export const AiLimitBanner = ({ aiLimit }) => {
  if (!aiLimit) return null;
  if (!aiLimit.active) {
    return aiLimit.cleared_at ? (
      <p data-testid="ai-limit-cleared" className="mt-4 text-xs text-muted-foreground">
        AI service daily limit last lifted {when(aiLimit.cleared_at)} ({aiLimit.cleared_by}).
      </p>
    ) : null;
  }
  const parked = aiLimit.parked || 0;
  return (
    <div data-testid="ai-limit-banner" className="mt-6 rounded-2xl border border-amber-300 bg-amber-50 text-amber-900 px-4 py-3 flex items-start gap-3">
      <Clock className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <p className="font-bold">AI service daily limit reached</p>
        <p className="mt-1">
          The Universal Key provider refused a call at <span data-testid="ai-limit-hit-at">{when(aiLimit.last_hit_at)}</span>
          {aiLimit.last_phase ? ` (${aiLimit.last_phase})` : ""}: “{aiLimit.last_error}”.
        </p>
        <p data-testid="ai-limit-parked" className="mt-1">
          {parked} duck{parked === 1 ? "" : "s"} that need Gemini {parked === 1 ? "is" : "are"} parked: no attempts used, nothing
          charged. fal.ai sculpts are not affected.
        </p>
        <p data-testid="ai-limit-next-probe" className="mt-1 text-xs opacity-80">
          One real call is let through every {aiLimit.probe_minutes || 30} minutes to check. Next check: {when(aiLimit.next_probe_at)}
          {aiLimit.probes ? ` · ${aiLimit.probes} check${aiLimit.probes === 1 ? "" : "s"} so far` : ""}. Parked ducks resume by themselves once a call succeeds.
        </p>
      </div>
    </div>
  );
};
